import declare from "dojo/_base/declare";
import Controller from "csi/action/Controller";
import reflection from "csi/reflection";
import { setLocationRevisionUrl, subscribeToLocation, unsubscribeToLocation } from "csi/router";
import { routerStore } from "csi/state/rootStore";

const StateActionController = declare(Controller, {
	/**
	 * @override
	 * Action is applied to selected revision
	 */
	constructor(params: Record<string, any>) {
		const { locationRevisionUrl, locationUrl } = routerStore;
		this.m_urlNode = locationRevisionUrl;
		this.m_urlParent = locationUrl;
		this.m_idAttrParent = reflection.ATTR_REVISIONS;

		// because action can cause many changes, we will query for the latest revision explicitly after action complete
		this.m_action.setReturnParameters({
			"Dep.Path": "Child:LatestRevision",
		});
	},

	/**
	 * @override
	 * Unsubscribe to location changes while action is processing, as we are only interested when other users (or browser tabs)
	 * invokes an action that changes revision state
	 */
	onStart() {
		unsubscribeToLocation();
	},

	/**
	 * @override
	 * Resubscribe to location if there was an error while performing the action
	 */
	onPublishError(err: Error) {
		const { locationNode, locationRevisionNode } = routerStore;
		subscribeToLocation(locationNode, locationRevisionNode);
	},

	/**
	 * @override
	 * Navigate to new revision
	 */
	postProcessSuccess() {
		const master = this.getParent();
		const revisionUrl = master.Revisions.last();
		return setLocationRevisionUrl(revisionUrl);
	},
});

export = StateActionController;
